import type { Environment } from 'types/environment'
import type { BannerResponse } from 'types/storyblok'

export function getContentByCountryCode(content: BannerResponse | undefined, countryCode: Environment.CountryCode, storeCode: Environment.StorefrontCode) {
  const countryCodeOverride = countryCode.toLowerCase() as Environment.StorefrontCode
  const storeCodeOverride = storeCode

  const contentByCountryCode = content?.[countryCodeOverride]
  const contentByStoreCode = content?.[storeCodeOverride]

  return contentByCountryCode || contentByStoreCode
}
